export default __webpack_public_path__ + "static/media/tailwindcss-logo.017e1e30.svg";